module.exports = __webpack_public_path__ + "static/media/reina.77aac2ae.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/reina.jpeg
// module id = 293
// module chunks = 0